import React from "react";
import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { ImArrowRight, ImArrowLeft } from "react-icons/im";
import Edit from "./Edit";
import Languages from "./languages/Languages";
import Educations from "./education/Educations";
import Courses from "./courses/Courses";
import Experience from "./experience/Experience";
import Relatives from "./relatives/Relatives";
import Recommends from "./recommends/Recommends";
import Documents from "./documents/Documents";
import Signature from "./Signature";
import useAuth from "../../hooks/useAuth";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { ImForward } from "react-icons/im";
import BlinkingDownArrow from "../shared/BlinkingDownArrow";
import MyJustDate from "../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API;

const Moamadoot = (props) => {
  const { moamad_id, mekhraz_title, hagsha_aharon } = useParams();
  const { auth } = useAuth();
  const user_id = auth.user_id;
  const [page, setPage] = useState(1);
  const [moamad, setMoamad] = useState({});
  const [newM, setNewM] = useState({});
  const [user, setUser] = useState({});
  const [isUploading, setIsUploading] = useState(true);
  const [counter, setCounter] = useState(0);
  const [menuVisible, setMenuVisible] = useState(true);
  const [inSignCanvas, setInSignCanvas] = useState(false);
  const [readOnly, setReadOnly] = useState(
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now())
  );
  //let readOnly = false;
  let history = useNavigate();
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  //const now = MyJustDate(new Date());

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData1 = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "jobs/moamadoot/" + moamad_id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setMoamad(response.data);
          setNewM(response.data);
          if (response.data.signature_date !== null) {
            setReadOnly(true);
          }
          setIsUploading(false);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    const getData2 = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "auth/users/" + user_id,
          {
            signal: controller.signal,
          }
        );
        setUser(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData2();
    getData1();
  }, [counter]);

  const toggleMenu = () => {
    setMenuVisible((prevVisible) => !prevVisible);
  };
  const isMobile = window.innerWidth <= 768;

  const MenuIndicator = () => (
    <>
      {isMobile && (
        <div className={`menu-indicator ${menuVisible ? "open" : "closed"}`}>
          {menuVisible ? (
            <>
              <ImArrowRight />
              {" גרור להסתרת תפריט הצד"}
            </>
          ) : (
            <>
              {"גרור להצגת תפריט הצד "}
              <ImArrowLeft />
            </>
          )}
        </div>
      )}
    </>
  );

  const SlideArea = () => <div className="slide-area" onClick={toggleMenu} />;
  useEffect(() => {
    const handleTouchMove = (e) => {
      const { touches } = e;

      // Adjust the threshold based on your design
      const threshold = 200;
      const touchStartX = touches[0].clientX; // Get the X coordinate of the touch start

      // Track horizontal swipe direction
      let swipeDirection = null;
      if (touchStartX < threshold) {
        swipeDirection = "right"; // Swipe towards right
      } else {
        swipeDirection = "left"; // Swipe towards left
      }

      if (inSignCanvas) {
        setMenuVisible(false);
      } else {
        if (swipeDirection === "right") {
          setMenuVisible(true); // Swipe towards right, show menu
        } else if (swipeDirection === "left") {
          setMenuVisible(false); // Swipe towards left, hide menu
        }
      }
    };

    document.addEventListener("touchmove", handleTouchMove, { passive: true });

    return () => {
      document.removeEventListener("touchmove", handleTouchMove);
    };
  }, [inSignCanvas]);
  // Update based on inSignCanvas changes

  return (
    <>
      <MenuIndicator />
      <SlideArea />
      {menuVisible && (
        <nav className="navbar navbar-expand-md bg-dark navbar-dark fixed-right">
          <a href="#" className="navbar-brand mb-0 h1">
            פרטי המועמדות
            <BlinkingDownArrow />
          </a>

          <ul className="navbar-nav flex-column ml-auto">
            <li className="nav-item ">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => history(-1)}
              >
                <ImForward />
                חזרה
              </button>
            </li>
            <li className="nav-item active">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(1)}
                disabled={isUploading ? true : false}
              >
                פרטים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(2)}
                disabled={isUploading ? true : false}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.language_moamad?.length}
                </span>
                -שפות
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(3)}
                disabled={isUploading ? true : false}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.education_moamad?.length}
                </span>
                -השכלה
              </button>
            </li>
            <li>
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(4)}
                disabled={isUploading ? true : false}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.course_moamad?.length}
                </span>
                -קורסים והשתלמיות
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(5)}
                disabled={isUploading ? true : false}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.workexperience_moamad?.length}
                </span>
                -ניסיון תעסוקתי
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(6)}
                disabled={isUploading ? true : false}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.relative_moamad?.length}
                </span>
                -קירבה
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(7)}
                disabled={isUploading ? true : false}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.recommend_moamad?.length}
                </span>
                -ממליצים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(8)}
                disabled={isUploading ? true : false}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.moamaddocument_moamad?.length}
                </span>
                -מסמכים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-default navbar-btn"
                style={{ color: "white" }}
                onClick={() => setPage(9)}
                disabled={isUploading ? true : false}
              >
                <span style={{ color: "#00FFFF" }}>חתימה ושיגור</span>
              </button>
            </li>
          </ul>
        </nav>
      )}
      {!isUploading ? null : (
        <div>
          <center>
            <Spinner animation="border" variant="danger" visible />
            <label>המתן עד סיום הפעולה.</label>
          </center>
        </div>
      )}
      <div
      //style={{ paddingRight: "90px" }}
      >
        {page === 1 && (
          <Edit
            visible={String(page === 1)}
            newM={newM}
            setNewM={setNewM}
            moamad={moamad}
            setMoamad={setMoamad}
            uEmail={user.email}
            mekhraz_title={mekhraz_title}
            hagsha_aharon={hagsha_aharon}
            disabled={isUploading ? false : true}
            readOnly={readOnly}
          />
        )}
        {page === 2 && (
          <Languages
            visible={String(page === 2)}
            moamad={moamad}
            hagsha_aharon={hagsha_aharon}
            readOnly={readOnly}
            counter={counter}
            setCounter={setCounter}
          />
        )}
        {page === 3 && (
          <Educations
            visible={String(page === 3)}
            moamad={moamad}
            hagsha_aharon={hagsha_aharon}
            readOnly={readOnly}
            counter={counter}
            setCounter={setCounter}
          />
        )}
        {page === 4 && (
          <Courses
            visible={String(page === 4)}
            moamad={moamad}
            hagsha_aharon={hagsha_aharon}
            readOnly={readOnly}
            counter={counter}
            setCounter={setCounter}
          />
        )}
        {page === 5 && (
          <Experience
            visible={String(page === 5)}
            moamad={moamad}
            hagsha_aharon={hagsha_aharon}
            readOnly={readOnly}
            counter={counter}
            setCounter={setCounter}
          />
        )}
        {page === 6 && (
          <Relatives
            visible={String(page === 6)}
            moamad={moamad}
            hagsha_aharon={hagsha_aharon}
            readOnly={readOnly}
            counter={counter}
            setCounter={setCounter}
          />
        )}
        {page === 7 && (
          <Recommends
            visible={String(page === 7)}
            moamad={moamad}
            hagsha_aharon={hagsha_aharon}
            readOnly={readOnly}
            counter={counter}
            setCounter={setCounter}
          />
        )}
        {page === 8 && (
          <Documents
            visible={String(page === 8)}
            moamad={moamad}
            hagsha_aharon={hagsha_aharon}
            readOnly={readOnly}
            counter={counter}
            setCounter={setCounter}
          />
        )}
        {page === 9 && (
          <Signature
            visible={String(page === 9)}
            moamad={moamad}
            hagsha_aharon={hagsha_aharon}
            readOnly={readOnly}
            menuVisible={menuVisible}
            setMenuVisible={setMenuVisible}
            inSignCanvas={inSignCanvas}
            setInSignCanvas={setInSignCanvas}
            languagesNum={moamad.language_moamad.length}
            coursesNum={moamad.course_moamad.length}
            relativesNum={moamad.relative_moamad.length}
            educationNum={moamad.education_moamad.length}
            workExperienceNum={moamad.workexperience_moamad.length}
            recommandsNum={moamad.recommend_moamad.length}
            documentsNum={moamad.moamaddocument_moamad.length}
          />
        )}
      </div>
    </>
  );
};

export default Moamadoot;
